import {
  DISABLED_ACTION_TOKENS,
  PRIMARY_ACTION_TOKENS,
  SECONDARY_ACTION_TOKENS
} from '../../../theme/tokens/actionColors'

export const SPECIAL_FORM_HEADER_ACTION_BUTTON_SX = {
  minWidth: 118,
  height: 34,
  borderRadius: '4px',
  px: 2,
  fontSize: '12px',
  fontWeight: 700,
  letterSpacing: '0.04em',
  textTransform: 'uppercase',
  boxShadow: 'none',
  '& .MuiButton-startIcon, & .MuiButton-endIcon': {
    color: 'inherit'
  },
  '& .material-symbols-outlined': {
    color: 'inherit'
  }
}

export const getSpecialFormHeaderActionSx = (variant) => {
  if (variant === 'contained') {
    return {
      ...SPECIAL_FORM_HEADER_ACTION_BUTTON_SX,
      backgroundColor: PRIMARY_ACTION_TOKENS.main,
      color: PRIMARY_ACTION_TOKENS.contrastText,
      border: `1px solid ${PRIMARY_ACTION_TOKENS.main}`,
      '&:hover': {
        backgroundColor: PRIMARY_ACTION_TOKENS.hoverStrong,
        borderColor: PRIMARY_ACTION_TOKENS.hoverStrong,
        boxShadow: 'none'
      },
      '&.Mui-disabled': {
        backgroundColor: DISABLED_ACTION_TOKENS.background,
        borderColor: DISABLED_ACTION_TOKENS.border,
        color: DISABLED_ACTION_TOKENS.text
      }
    }
  }

  return {
    ...SPECIAL_FORM_HEADER_ACTION_BUTTON_SX,
    borderColor: SECONDARY_ACTION_TOKENS.border,
    color: SECONDARY_ACTION_TOKENS.text,
    backgroundColor: SECONDARY_ACTION_TOKENS.background,
    '&:hover': {
      borderColor: SECONDARY_ACTION_TOKENS.borderHover,
      backgroundColor: SECONDARY_ACTION_TOKENS.backgroundHover
    }
  }
}
